import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useShopCategories = (userToken, setIsLoading) => {
  const baseUrl = useBaseUrl()
  const [shopCategories, setShopCategories] = useState(null);
  useEffect(() => {
    const fetchShopCategories = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/shop/category`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setIsLoading(false);
        setShopCategories(response.data.categories);
      } catch (error) {
        console.log("Error during getting shop category", error);
      }
    };
    if (userToken) {
      fetchShopCategories();
    }
  }, [baseUrl, userToken]);

  return { shopCategories };
};

export default useShopCategories;
